import React from "react";
import { FileCheck, Scale, Lock, Handshake } from "lucide-react";

const items = [
  {
    icon: FileCheck,
    title: "Fixed scope, fixed timeline",
    body: "Every engagement begins with a short, clearly defined pilot — defined days, defined deliverables, agreed on one page before we start. No open-ended consulting.",
  },
  {
    icon: Scale,
    title: "Accountable in writing",
    body: "Every pilot closes with a jointly scored checklist. If we miss the agreed mark, a partial refund applies. Delivery is measured, not claimed.",
  },
  {
    icon: Lock,
    title: "Your information stays yours",
    body: "An NDA protects your commercial information throughout. We need no access to your accounts or costing to do our work.",
  },
  {
    icon: Handshake,
    title: "Our stance",
    body: "We do not presume to teach you your business. We organize what you have already built — so it runs, measures and scales without depending on any one person.",
  },
];

export default function HowWeWork() {
  return (
    <section
      id="how-we-work"
      data-testid="how-we-work"
      className="px-6 md:px-12 lg:px-24 py-24 md:py-32 border-t border-sebyx-border"
    >
      <div className="flex items-center gap-3 mb-6">
        <span className="block w-8 h-px bg-sebyx-accent" />
        <span className="font-mono text-[11px] tracking-[0.3em] uppercase text-sebyx-accent">
          [04] How We Work
        </span>
      </div>
      <h2
        data-testid="how-we-work-headline"
        className="font-display text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tighter text-sebyx-text leading-[1.05] max-w-3xl"
      >
        Built so an owner can say{" "}
        <span className="text-sebyx-accent italic font-light">yes</span>{" "}
        comfortably.
      </h2>

      <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 gap-5 max-w-5xl">
        {items.map((it, i) => (
          <div
            key={it.title}
            data-testid={`how-we-work-item-${i}`}
            className="flex gap-5 border border-sebyx-border bg-sebyx-surface p-6 md:p-7"
          >
            <it.icon className="text-sebyx-accent shrink-0 mt-1" size={22} />
            <div>
              <h3 className="font-display text-base md:text-lg font-semibold text-sebyx-text">
                {it.title}
              </h3>
              <p className="mt-2 font-body text-sm text-sebyx-muted leading-relaxed">
                {it.body}
              </p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
